import { useState } from "react"
import { Helmet } from "react-helmet"
import { useNavigate } from "react-router-dom"
import GulfStudents3 from "../../../Assets/Gulf_Students/Career_Internship_Prep.webp"
import GulfStudentsData from "../../../Data/Gulf_Students/GulfStudentsData"
import CareerInternshipData from "../../../Data/Gulf_Students/Services_Data/CareerInternshipData"
import HowToUseItCAndIPrepData from "../../../Data/Gulf_Students/Services_Data/HowToUseItCAndIPrepData"
import CareerInternshipPrepData from "../../../Data/Gulf_Students/Testimonial_Data/CareerInternshipPrepData"
import "../../CSS/GulfStudentsCSS.css"
import "../../CSS/GulfStudentsForm.css"
import TestimonialCard from "../TestimonialCard"

const CarrerInternship = () => {
    const navigate = useNavigate();
    const [stuName, setStuName] = useState();
    const [email, setEmail] = useState();
    const [year, setYear] = useState();
    const [interest, setInterest] = useState();
    const handleSubmit = (e) => {
        if (!stuName || !email || !year ||!interest) {
            alert("Please Fill all the details before submitting the form.");
            return;
        }
        e.preventDefault();
        // const form = document.getElementById('career-internship-form');
        const form = e.target;
        const data = new FormData(form);

        fetch('/', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams(data).toString(),
        })
            .then(() => {
                setStuName('');
                setEmail('');
                setYear('');
                setInterest('');
                navigate('/career-internship-success');
            })
            .catch((error) => console.log(error));
    };
    return (
        <>
            <Helmet>
                <title>Holistic Learning : Career & Internship Prep</title>
                <meta name="description" content="Download your free Career Prep Kit for Gulf students. Resume templates, LinkedIn tips, and internship strategies." />
                <link rel="canonical" href="https://holisitclearning.com/gulf-students/career-prep" />
            </Helmet>
            <section className="pre-departure-gulf-students-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-between">
                        <div className="col-md-6 pre-departure-gulf-students-heading-and-para-div">
                            <div className="pre-departure-gulf-students-heading-and-para-first-inner-div">
                                <h2><span>Career & Internship</span> Prep</h2>
                                <p>Studying abroad is just the beginning—your future career starts now. Our Career Prep Kit helps Gulf students build standout resumes, optimize LinkedIn profiles, prepare for interviews, and understand CPT/OPT pathways. Whether you're aiming for internships, part-time jobs, or full-time roles after graduation, this free toolkit gives you the edge. Download it today and take the first step toward your global career.</p>
                            </div>
                        </div>
                        <div className="col-md-6 pre-departure-gulf-students-image-div">
                            <img src={GulfStudents3} alt="" className='img-fluid' />
                        </div>
                    </div>
                </div>
            </section>
            <section className="leaving-your-abroad-soon-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-start">
                        <div className="col-md-12 leaving-your-abroad-soon-heading-div">
                            <h2><span>Planning Your Future</span> Beyond The Classroom?</h2>
                            <h4>We help Gulf students build abroad-ready resumes, LinkedIn profiles, and internship strategies.</h4>
                        </div>
                    </div>
                </div>
            </section>
            <section className="planning-to-study-abroad-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-md-12 planning-to-study-abroad-heading-div">
                            <h2>What’s Inside the <span>Career Kit</span>:</h2>
                        </div>
                    </div>
                    <div className="row justify-content-between">
                        {
                            CareerInternshipData.map((item) => {
                                return (
                                    <div className="col-lg-3 col-md-6 col-sm-6 planning-to-study-abroad-card-div" key={item.id}>
                                        <div className="gulf-student-card-inner-div">
                                            <div className="what-we-offer-card-icon">
                                                <img src={item.bannerImg} alt="" />
                                            </div>
                                            <p>{item.text}</p>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </section>
            <section className="why-it-matters-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-start">
                        <div className="col-md-12 why-it-matters-heading-div">
                            <h2><span>Bonus</span></h2>
                            <h4>Templates and interview prep guides included.</h4>
                        </div>
                    </div>
                </div>
            </section>
            <section className="why-it-matters-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-start">
                        <div className="col-md-12 why-it-matters-heading-div">
                            <h2><span>Why</span> It Matters:</h2>
                            <h4>Studying abroad opens doors — but landing the right internship or job takes preparation. Gulf students often face unique challenges: unfamiliar hiring systems, visa restrictions, and limited local networks. The Career Prep Kit bridges that gap. It helps you build a standout resume, optimize your LinkedIn profile, understand CPT/OPT rules, and prepare for interviews with confidence. Because your career doesn’t start after graduation — it starts now.</h4>
                        </div>
                    </div>
                </div>
            </section>
            <section className="why-it-matters-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-md-12 why-it-matters-heading-div">
                            <h2><span>How</span> To Use It</h2>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        {
                            HowToUseItCAndIPrepData.map((item) => {
                                return (
                                    <div className="col-lg-4 col-md-6 col-sm-6 planning-to-study-abroad-card-div" key={item.id}>
                                        <div className="gulf-student-card-inner-div">
                                            <div className="what-we-offer-card-icon">
                                                <img src={item.bannerImg} alt="" />
                                            </div>
                                            <p>{item.text}</p>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </section>
            <section className="contact-now-access-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-md-12 contact-now-access-heading-div">
                            <h2>Get <span>Career-Ready</span></h2>
                        </div>
                        <div className="col-md-12 contact-now-form">
                            <form name="career-internship-form" id="career-internship-form" method="post" action="/career-internship-success" enctype="multipart/form-data" netlify-honeypot="bot-field" data-netlify-recaptcha="true" data-netlify="true" onSubmit={handleSubmit}>
                                <input type="hidden" name="form-name" value="career-internship-form" />
                                <div className="row justify-content-center">
                                    <div className="col-md-6 mb-3 gulf-students-services-form-div">
                                        <label htmlFor="name" className="form-label">Name</label>
                                        <input type="text" className="form-control" id="name" name='name' value={stuName} onChange={(e) => setStuName(e.target.value)} />
                                    </div>
                                    <div className="col-md-6 mb-3 gulf-students-services-form-div">
                                        <label htmlFor="email" className="form-label">Email</label>
                                        <input type="email" className="form-control" id="email" name='email' value={email} onChange={(e) => setEmail(e.target.value)} />
                                    </div>
                                    <div className="col-md-6 mb-3 gulf-students-services-form-div">
                                        <label htmlFor="graduation" className="form-label">Graduation Year</label>
                                        <input type="number" className="form-control" id="graduation" name='graduation' value={year} onChange={(e) => setYear(e.target.value)} />
                                    </div>
                                    <div className="col-md-6 mb-3 gulf-students-services-form-div">
                                        <label htmlFor="interest" className="form-label">Career Interest</label>
                                        <input type="text" className="form-control" id="interest" name='interest' value={interest} onChange={(e) => setInterest(e.target.value)} />
                                    </div>
                                    <div className="col-md-12 mb-3 gulf-students-services-button-div">
                                        <button type="submit">Access My Career Kit</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
            <section className="other-services-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-md-12 other-services-heading-div">
                            <h2>Other <span>Services</span></h2>
                        </div>
                    </div>
                    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-4 row-cols-lg-4 row-cols-xl-4">
                        {
                            GulfStudentsData.filter(item => item.id !== 4)
                                .map((item) => {
                                    return (
                                        <div className="col our-services-card-div" key={item.id}>
                                            <div className="our-services-card-inner-div">
                                                <div className="what-we-offer-card-icon">
                                                    <img src={item.bannerImg} alt="" />
                                                </div>
                                                <h5>{item.heading}</h5>
                                                <p>{item.text}</p>
                                                {item.link}
                                            </div>
                                        </div>
                                    )
                                })
                        }
                    </div>
                </div>
            </section>
            <TestimonialCard data={CareerInternshipPrepData} title={<><span>Social</span> Proof</>} />
        </>
    )
}

export default CarrerInternship